import pino from 'pino';
import { isNil, setRootLogger } from '@lucidlink/tscore';
import { InvalidArgumentError } from '#common/types';
import { JsonConsoleLogger } from './types';
// pino does not support the following features in the browser:
//  - pretty logging
//  - file logging
//  - redaction (mask sensitive information)
export function setUpLogging(logConfig = JsonConsoleLogger) {
    if (logConfig.pretty || !isNil(logConfig.filePath)) {
        throw new InvalidArgumentError('Unsupported log configuration');
    }
    const rootLogger = pino({
        level: logConfig.logLevel,
        timestamp: pino.stdTimeFunctions.isoTime,
        browser: { asObject: true },
    });
    setRootLogger(rootLogger);
}
